import { createSlice } from "@reduxjs/toolkit"

const collapseLayout = createSlice({
  name: "collapseLayout",
  initialState: { collapseOpen: false },
  reducers: {
    toggleCollapse(state) {
      state.collapseOpen = !state.collapseOpen
    },
    closeCollapse(state) {
      state.collapseOpen = false
    },
    openCollapse(state) {
      state.collapseOpen = true
    },
  },
})

export const { toggleCollapse, closeCollapse, openCollapse } =
  collapseLayout.actions

export default collapseLayout.reducer
